export default "__VITE_ASSET__DXIouceU__"